import script from "./CardDelivererReduced.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardDelivererReduced.vue?vue&type=script&setup=true&lang=ts"

import "./CardDelivererReduced.vue?vue&type=style&index=0&id=7c46c1ed&lang=css"

const __exports__ = script;

export default __exports__